import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: #f0f2f5;
  padding: 0;
  margin: 0;
`;

const TopBar = styled.div`
  background: #003b70;
  padding: 1rem 2rem;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;

const BackButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.5rem 1rem;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const MainContent = styled.div`
  max-width: 1000px;
  margin: 2rem auto;
  padding: 0 2rem;
`;

const Content = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
`;

const TestIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: ${props => props.color || '#003b70'};
`;

const Title = styled.h1`
  color: #1a1a1a;
  font-size: 1.75rem;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
`;

const SubTitle = styled.p`
  color: #666;
  margin: 0;
  font-size: 1rem;
`;

const InstructionSection = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #003b70;
`;

const SectionTitle = styled.h2`
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0 0 1rem 0;
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0.8rem;
    padding-left: 1.5rem;
    position: relative;
    color: #4a4a4a;
    line-height: 1.6;

    &:before {
      content: "•";
      color: ${props => props.bulletColor || '#003b70'};
      position: absolute;
      left: 0;
      font-weight: bold;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StartButton = styled.button`
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 2rem auto 0;
  background: #003b70;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #002b53;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

const TimeLimit = styled.div`
  display: inline-block;
  background: #f8d7da;
  color: #721c24;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  margin-top: 1rem;
`;

const BaseInstructionScreen = ({ 
  title, 
  icon, 
  iconColor,
  bulletColor,
  onBack, 
  onStart,
  children 
}) => {
  return (
    <Container>
      <TopBar>
        <Logo>TOEFL Practice Test</Logo>
        <BackButton onClick={onBack}>← Back to Test Selection</BackButton>
      </TopBar>
      <MainContent>
        <Content>
          <Header>
            <TestIcon color={iconColor}>{icon}</TestIcon>
            <Title>{title}</Title>
            <SubTitle>Please read the instructions carefully before starting</SubTitle>
          </Header>
          {children}
          <StartButton onClick={onStart}>
            Start Test Now
          </StartButton>
        </Content>
      </MainContent>
    </Container>
  );
};

export { 
  BaseInstructionScreen, 
  List, 
  InstructionSection, 
  SectionTitle,
  TimeLimit 
}; 